/* eslint-disable no-restricted-globals */
import React, { useState } from "react";
import SiteHeader from "@/components/common/SiteHeader";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/shared/ui/select";
import { Button } from "@/components/shared/ui/button";
import { UTILITY_REDIRECT_URI, utilityEnv } from "@/lib/utilityEnv";

const getUrl = (utilityName: string) => {
  const prod = utilityEnv() === "prod";
  let baseUrl = "";
  if (utilityName === "ORU") {
    baseUrl = prod ? "https://www.oru.com/en/" : "https://uat10.oru.com/en/";
  } else if (utilityName === "ConEdison") {
    baseUrl = prod
      ? "https://www.coned.com/en/"
      : "https://uat10.coned.com/en/";
  }
  const bulkId = prod ? "48" : "91";
  const clientId = prod ? "0oa14dlmdcwA0BAju0x8" : "0oa21l77rimuWAp9Z0h8";
  const redirectUri = UTILITY_REDIRECT_URI[utilityEnv()];
  return (
    `${baseUrl}oauth/authorize?scope=FB=1_3_4_5_7_10_15_16_51_53_56_57_58_60;` +
    "IntervalDuration=Monthly_3600_900_300;BlockDuration=Monthly_Daily;HistoryLength=63072000;" +
    `BR=0000${bulkId}&response_type=code&client_id=${clientId}` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}&state=none`
  );
};

const utilityOptions = [
  {
    value: "ORU",
    label: "Orange & Rockland",
  },
  {
    value: "ConEdison",
    label: "ConEdison",
  },
];

const UtilityAuth = () => {
  const [utilityName, setUtilityName] = useState("ConEdison");

  const searchParams = useSearch({ strict: false }) as any;
  if (searchParams.utility_auth_id) {
    localStorage.setItem("utilityAuthId", searchParams.utility_auth_id);
  }

  const handleSubmit = () => {
    const url = getUrl(utilityName);
    if (url) {
      window.location.href = url;
    }
  };
  return (
    <div className="flex flex-col w-full">
      <SiteHeader header="Authorize Sharing Utility Data" />
      <div className="px-10 py-8 max-w-[600px]">
        <div>Select a utility</div>
        <Select
          onValueChange={(val) => setUtilityName(val)}
          defaultValue={utilityName}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Select a utility provider" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              {utilityOptions.map((utility) => (
                <SelectItem key={utility.value} value={utility.value}>
                  {utility.label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
        <div className="mt-6">
          <Button onClick={handleSubmit}>Authorize with {utilityName}</Button>
        </div>
      </div>
    </div>
  );
};

export const Route = createFileRoute("/external/initiate_utility_auth")({
  component: UtilityAuth,
});
